






























































import {Component, PropSync, Watch} from 'vue-property-decorator'
  import {Getter, Action} from "vuex-class";
  import BaseFilter from "@/components/Filter/BaseFilter";
  import {ServiceProviderFilter} from "@/store/settings/service_providers/types";
  import {SelectWings, ToggleWings, InputWings} from "wings-ui-components";
  import {notifyError} from "@/utils/notify-helper";
  import {getTranslatedParams} from "@/utils/notify-utils";

  @Component({components: {SelectWings, ToggleWings, InputWings}})
  export default class ServiceProvidersFilter extends BaseFilter<ServiceProviderFilter>{
    @PropSync('filterProp') filterParent!: any;
    @PropSync('runFilter') run!: any;
    @PropSync('show') is_show!: boolean;
    @Getter("transports") transportsList: any;
    @Action("getServiceProviders") actionGetServiceProviders: any;
    @Action("getTransports") actionGetTransports: any;
    @Action("exportServiceProviders") actionExportServiceProviders: any;
    statusList:number[] = [1,0];

    defaultFilter(): ServiceProviderFilter {
      return {
        id: undefined,
        name: undefined,
        transport: undefined,
        status: undefined,
        page_number: 1
      }
    }

    created() {
      this.actionGetTransports();
      this.filtered();
      this.scroll();
    }

    export(): void {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Export",
        action_status: "success",
        object_type: "Service provider",
        addititional_info: getTranslatedParams(this.filter)
      }
      this.actionExportServiceProviders(this.filter).then(()=>{
        this.actionLog(this.logObject);
      }).catch((error: any) =>{
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error)
      })
    }

    async onFilteredAction(nextPage = false) {
      if (!nextPage) this.filter.page_number = 1;
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Service provider",
          addititional_info: getTranslatedParams(this.filter)
        };
        const resp = await this.actionGetServiceProviders(this.filter)
        await this.actionLog(this.logObject);
        this.is_last = resp.length == 0;
      } catch (err) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(err);
      } finally {
        this.moreLoading = false;
      }
    }

    get transportsForProviders() {
      return [...this.transportsList.filter((value:any) => value.name.toLowerCase() !== 'push' && value.name.toLowerCase() !== 'ussd')]
    }

    @Watch('filter', {immediate: true, deep: true})
    onFilterChanged(val: ServiceProviderFilter) {
      this.filterParent = val;
    }

    @Watch('run')
    onRunFilter(val: boolean) {
      if (!val) return;
      this.filtered();
      this.run = false;
    }
  }
